module.exports = __webpack_public_path__ + "fonts/iconfont.ffad508b.woff";